<template>
  <div class="pl-1 w-full">
    <div class="d-flex align-center pr-2 justify-space-between">
      <div class="d-flex align-center">
        <p
          class="ma-0 font-16 font-weight-medium pl-1 text-truncate"
          :title="Helpers.primeiraLetraMaiuscula(PRODUTO_SELECIONADO.descricao_produto)"
          v-text="Helpers.primeiraLetraMaiuscula(PRODUTO_SELECIONADO.descricao_produto)"
        />

        <DetalhesProdutoTelaCheia
          :produto="PRODUTO_FORMATO_PROP.tabela"
          :habilitar_edicao_parametros="!PRODUTO_SELECIONADO.produto_eh_categoria"
          :atualizar_detalhes_count="atualizar_detalhes_count"
          ativar_filtro_revenda_direta
          @update:lote-minimo="atualizarDetalhesProduto"
          @update:tempo-ressuprimento="atualizarDetalhesProduto"
          @update:influencia-projecao="atualizarDetalhesProduto"
          @update:cobertura-manual-estoque="atualizarDetalhesProduto"
          @update:previsao-gatilho="atualizarDetalhesProduto"
          @update:similar="atualizarDetalhesProduto"
          @update:heranca="atualizarDetalhesProduto"
          @update:desconsiderar-pedido-em-transito="atualizarDetalhesProduto"
        />
      </div>

      <CoresCurvas :arvore_decisao="PRODUTO_SELECIONADO.arvore_decisao" />
    </div>

    <div :class="{'d-flex mt-n1': !VISAO_VERTICAL_ATIVA}" class="w-full">
      <TabelaDetalhesProdutos
        :produto="PRODUTO_FORMATO_PROP.tabela"
        :exibir_raio_x="false"
        :click_bar="click_bar"
        :class="{ 'w-50-porcento': !VISAO_VERTICAL_ATIVA, 'w-full': VISAO_VERTICAL_ATIVA }"
        class="ml-1"
        :habilitar_edicao_parametros="!PRODUTO_SELECIONADO.produto_eh_categoria"
        ativar_filtro_revenda_direta
        :atualizar_detalhes_count="atualizar_detalhes_count"
        @update:lote-minimo="atualizarDetalhesProduto"
        @update:tempo-ressuprimento="atualizarDetalhesProduto"
        @update:influencia-projecao="atualizarDetalhesProduto"
        @update:cobertura-manual-estoque="atualizarDetalhesProduto"
        @update:previsao-gatilho="atualizarDetalhesProduto"
        @update:similar="atualizarDetalhesProduto"
        @update:heranca="atualizarDetalhesProduto"
        @update:parametrizacao="atualizarDetalhesProduto"
        @update:desconsiderar-pedido-em-transito="atualizarDetalhesProduto"
        @update:tipo-projecao-aplicado="atualizarDetalhesProduto"
        @consumos-desconsiderados="atualizarDetalhesProduto"
      />

      <v-divider :vertical="!VISAO_VERTICAL_ATIVA" />

      <div
        class="ml-n3"
        :class="{ 'w-50-porcento mt-n7': !VISAO_VERTICAL_ATIVA, 'w-full mt-n3': VISAO_VERTICAL_ATIVA }"
        :style="FORMATAR_ALTURA_GRAFICO"
      >
        <GraficoMovimentacoesEstoqueProduto
          :produto="PRODUTO_FORMATO_PROP.grafico"
          :atualizar_detalhes_count="Number(atualizar_detalhes_count)"
          ativar_filtro_revenda_direta
          @click:bar="click_bar = $event"
          exibirFilialDropdown
        />
      </div>
    </div>
  </div>
</template>

<script>
import TabelaDetalhesProdutos from "@/components/produto/detalhes/TabelaDetalhesProdutos.vue";
import GraficoMovimentacoesEstoqueProduto from "@/components/produto/detalhes/grafico/GraficoMovimentacoesEstoqueProduto.vue";
import DetalhesProdutoTelaCheia from "@/components/produto/detalhes/Index";
import CoresCurvas from "@/components/compra/ProdutosGerais/DetalhesProduto/CoresCurvas";
import {mapGetters} from "vuex";

export default {
  name: "Index",
  components: {
    CoresCurvas,
    TabelaDetalhesProdutos,
    GraficoMovimentacoesEstoqueProduto,
    DetalhesProdutoTelaCheia
  },
  data: () => ({
    atualizar_detalhes_count: 0,
    exibir_mais_detalhes: false,
    click_bar: null,
  }),
  computed: {
    ...mapGetters({
      FILTROS_STORE: "CompraProdutosGerais/getFiltros",
    }),
    PRODUTO_SELECIONADO() {
      return this.$store.getters['CompraProdutosGerais/getProdutoSelecionado'];
    },
    PRODUTO_FORMATO_PROP() {
      return {
        tabela: {
          id_grupo: this.PRODUTO_SELECIONADO.id_grupo,
          id_filial: this.PRODUTO_SELECIONADO.filial || 9999,
          id_produto: this.PRODUTO_SELECIONADO.idproduto,
          produto_eh_combinacao: this.PRODUTO_SELECIONADO.produto_eh_combinacao || false,
          produto_eh_categoria: this.PRODUTO_SELECIONADO.produto_eh_categoria || false,
          exibir_produtos_inativos: this.FILTROS_STORE.exibir_produtos_inativos || false,
          incluir_apenas_produtos_ativos: true,
        },
        grafico: {
          grupo: this.PRODUTO_SELECIONADO.id_grupo,
          filial: this.PRODUTO_SELECIONADO.filial || 9999,
          produto: this.PRODUTO_SELECIONADO.idproduto,
          produto_eh_combinacao: this.PRODUTO_SELECIONADO.produto_eh_combinacao ? 'S' : 'N',
          produto_eh_categoria: this.PRODUTO_SELECIONADO.produto_eh_categoria ? 'S' : 'N',
          exibir_produtos_inativos: this.FILTROS_STORE.exibir_produtos_inativos ? 'S' : 'N',
          incluir_apenas_produtos_ativos: true,
        }
      }
    },
    VISAO_VERTICAL_ATIVA() {
      return this.$store.getters['CompraProdutosGerais/getVisaoVertical'];
    },
    CALLBACK_RECARREGAR_DADOS_TABELA_PRODUTOS() {
      return this.$store.getters["CompraProdutosGerais/callbackRecarregarTabelaProdutos"];
    },
    TIPO_PROJECAO_VENDAS() {
      const v = this.PRODUTO_SELECIONADO ? this.PRODUTO_SELECIONADO.tipo_projecao_vendas : null;
      return v != null && v !== "" ? String(v) : "padrao_systock";
    },
    FORMATAR_ALTURA_GRAFICO() {
      if (this.VISAO_VERTICAL_ATIVA) {
        if (this.TIPO_PROJECAO_VENDAS === 'padrao_systock') {
          return { height: 'calc(100vh - 393px)' }
        }

        return { height: '520px' }
      }

      return { height: '330px' }
    }
  },
  methods: {
    atualizarListaProdutos() {
      this.CALLBACK_RECARREGAR_DADOS_TABELA_PRODUTOS();
    },
    atualizarDetalhesProduto() {
      this.atualizar_detalhes_count++;
      this.atualizarListaProdutos();
    }
  }
}
</script>

<style scoped>

</style>
